import { UserMenuComponent } from './theme/components/user-menu/user-menu.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { EmailVerificationComponent } from './components/email-verification/email-verification.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { HodRegisterComponent } from './components/hod-register/hod-register.component';
import { LandingComponent } from './components/landing/landing.component';
import { LoginComponent } from './components/login/login.component';
import { LoginRegisterNavbarComponent } from './components/login-register-navbar/login-register-navbar.component';
import { RequestResetComponent } from './components/password/request-reset/request-reset.component';
import { ResponseResetComponent } from './components/password/response-reset/response-reset.component';
import { RegisterComponent } from './components/register/register.component';
import { EmailVerificationPopupComponent } from './components/register/email-verification-popup/email-verification-popup.component';
import { PidSelectComponent } from './components/register/pid-select/pid-select.component';
import { PidSelectInstituteComponent } from './components/institute-register/pid-select-institute/pid-select-institute.component';
import { StudentRegisterComponent } from './components/student-register/student-register.component';
import { AboutBodyComponent } from './components/landing/about-body/about-body.component';
import { DirectoryBodyComponent } from './components/landing/directory-body/directory-body.component';
import { HomeComponent } from './components/landing/home/home.component';
import { AnnouncementsComponent } from './components/landing/bulletin-body/announcements/announcements.component';
import { UpcomingComponent } from './components/landing/bulletin-body/upcoming/upcoming.component';
import { ContactBodyComponent } from './components/landing/contact-body/contact-body.component';
import { DownloadBodyComponent } from './components/landing/download-body/download-body.component';
import { FAQBodyComponent } from './components/landing/faqbody/faqbody.component';
import { GuidelineBodyComponent } from './components/landing/guideline-body/guideline-body.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LandingHeaderComponent } from './components/landing/landing-header/landing-header.component';
import { LandingFooterComponent } from './components/landing/landing-footer/landing-footer.component';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { AppSettings } from './app.settings';
import { ToastrModule } from 'ngx-toastr';
import { httpInterceptorProviders } from './http-interceptors';
import { JarwisService } from './Services/jarwis.service';
import { MenuService } from './theme/components/menu/menu.service';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true,
  suppressScrollX: true,
};
import { OverlayContainer } from '@angular/cdk/overlay';
import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { LoaderComponent } from './components/loader/loader.component';
import { ImageGalleryComponent } from './components/landing/image-gallery/image-gallery.component';
import { VideoGalleryComponent } from './components/landing/video-gallery/video-gallery.component';
import { MatInputModule } from '@angular/material/input';
import { SharedModule } from './shared/shared.module';
import { LeadershipTeamComponent } from './components/landing/leadership-team/leadership-team.component';
import { MessagesComponent } from './components/landing/messages/messages.component';
import { InstituteRegisterComponent } from './components/institute-register/institute-register.component';
import { FacultyRegisterComponent } from './components/faculty-register/faculty-register.component';
import { NonAicteRegisterPopupComponent } from './components/institute-register/non-aicte-register-popup/non-aicte-register-popup.component';
// import { NoRightClickDirective } from './directives/no-right-click.directive';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { TemporaryDashboardComponent } from './temporary-dashboard/temporary-dashboard.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgApexchartsModule } from 'ng-apexcharts';
import { InstituteDashboardComponent } from './temporary-dashboard/institute-dashboard/institute-dashboard.component';
import { StudentAssessmentDetailsComponent } from './temporary-dashboard/institute-dashboard/student-assessment-details/student-assessment-details.component';
import { InstituteDashboardDetailsComponent } from './temporary-dashboard/institute-dashboard/institute-dashboard-details/institute-dashboard-details.component';
import { GapAnalysisDashboardComponent } from './temporary-dashboard/institute-dashboard/gap-analysis-dashboard/gap-analysis-dashboard.component';
// import { ViewProfileComponent } from './temporary-dashboard/institute-dashboard/view-profile/view-profile.component';
// import { InstituteProfileComponent } from './temporary-dashboard/institute-dashboard/view-profile/institute-profile/institute-profile.component';
// import { StudentProfileComponent } from './temporary-dashboard/institute-dashboard/view-profile/student-profile/student-profile.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
// import { ViewProfileComponent } from './temporary-dashboard/institute-dashboard/view-profile/view-profile.component';
// import { InstituteProfileComponent } from './temporary-dashboard/institute-dashboard/view-profile/institute-profile/institute-profile.component';
// import { StudentProfileComponent } from './temporary-dashboard/institute-dashboard/view-profile/student-profile/student-profile.component';
import { ViewVideoComponent } from './components/landing/video-gallery/view-video/view-video.component';
import { StudentSelfRegisterComponent } from './components/student-self-register/student-self-register.component';
import { SelectInstituteComponent } from './components/student-self-register/select-institute/select-institute.component';
import { StudentSelfRegistrationPopupComponent } from './components/student-self-register/student-self-registration-popup/student-self-registration-popup.component';
import { UnderMaintenanceComponent } from './pages/errors/under-maintenance/under-maintenance.component';
import { DatePipe } from '@angular/common';
import { GrievanceComponent } from './components/grievance/grievance.component';
import { GrievanceTableComponent } from './components/grievance-table/grievance-table.component';
import { ViewGrievanceUserComponent } from './components/grievance-table/view-grievance-user/view-grievance-user.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { InstituteDetailsComponent } from './components/institute-details/institute-details.component';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { LoginResetPasswordPopupComponent } from './components/login-reset-password-popup/login-reset-password-popup.component';
import { RequestResetOtpComponent } from './components/password/request-reset-otp/request-reset-otp.component';



@NgModule({
  declarations: [
    AppComponent,
    UserMenuComponent,
    EmailVerificationComponent,
    HodRegisterComponent,
    LandingComponent,
    LoaderComponent,
    LoginComponent,
    LoginRegisterNavbarComponent,
    RequestResetComponent,
    ResponseResetComponent,
    RegisterComponent,
    EmailVerificationPopupComponent,
    PidSelectComponent,
    PidSelectInstituteComponent,
    StudentRegisterComponent,
    HomeComponent,
    AboutBodyComponent,
    DirectoryBodyComponent,
    GuidelineBodyComponent,
    DownloadBodyComponent,
    FAQBodyComponent,
    ContactBodyComponent,
    UpcomingComponent,
    AnnouncementsComponent,
    LandingHeaderComponent,
    LandingFooterComponent,
    NotFoundComponent,
    ImageGalleryComponent,
    VideoGalleryComponent,
    UserMenuComponent,
    LeadershipTeamComponent,
    MessagesComponent,
    InstituteRegisterComponent,
    FacultyRegisterComponent,
    NonAicteRegisterPopupComponent,
    TemporaryDashboardComponent,
    InstituteDashboardComponent,
    StudentAssessmentDetailsComponent,
    InstituteDashboardDetailsComponent,
    GapAnalysisDashboardComponent,
    ViewVideoComponent,
    // ViewProfileComponent,
    // InstituteProfileComponent,
    // StudentProfileComponent,
    StudentSelfRegisterComponent,
    SelectInstituteComponent,
    StudentSelfRegistrationPopupComponent,
    GrievanceComponent,
    GrievanceTableComponent,
    ViewGrievanceUserComponent,
    ResetPasswordComponent,
    InstituteDetailsComponent,
    LoginResetPasswordPopupComponent,
    RequestResetOtpComponent,
    // ViewProfileComponent,
    // InstituteProfileComponent,
    // StudentProfileComponent,
    // NoRightClickDirective,
  ],

  imports: [
    BrowserModule,
    RouterModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule,
    MatExpansionModule,
    NgbModule,
    MatListModule,
    MatIconModule,
    MatSidenavModule,
    HttpClientModule, 
     
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: false,
    }), // ToastrModule added
    MatCardModule,
    MatInputModule,
    SharedModule,
    PerfectScrollbarModule,
    NgxChartsModule,
    NgApexchartsModule,
    CarouselModule,
    YouTubePlayerModule
  ],

  providers: [
    AppSettings,
    httpInterceptorProviders,
    JarwisService,
    MenuService,
    DatePipe,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
